import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import DictTag from "@/components/DictTag/index.vue";

Vue.config.productionTip = false
Vue.use(ElementUI);
// 全局组件挂载
Vue.component('DictTag', DictTag)

export const bus = new Vue();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
